import { useEffect } from "react";
import type { ViewContext } from "../types";
import { BookingLoading } from "../parts";

// /payment/success/<booking>: after paying, the booking's confirmation.
// Port of v1's payment/success/[booking] page, which shows nothing of its
// own: it redirects to /classroom/<booking>, which v1 redirects on to
// /bookings/manage/<booking>. Here the manage page is on the same site, so
// it goes there in one step (replacing this address, as a redirect does);
// the manage page checks the booking is this school's.

export function PaymentSuccessView({ ctx, bookingId }: { ctx: ViewContext; bookingId: string }) {
  const href = ctx.links.manage(bookingId);
  useEffect(() => {
    window.location.replace(href);
  }, [href]);
  return (
    <div className="space-y-4">
      <BookingLoading rows={2} />
      <p className="text-center text-sm text-muted-foreground">
        Taking you to your booking…{" "}
        <a className="font-medium text-primary underline-offset-4 hover:underline" href={href}>
          Open it now
        </a>
      </p>
    </div>
  );
}
